import script from "./ViewATeamInSOP.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewATeamInSOP.vue?vue&type=script&setup=true&lang=js"

import "./ViewATeamInSOP.vue?vue&type=style&index=0&id=795fb834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795fb834"]])

export default __exports__